"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app-channellist",
    class: {
      'app-channellist-padding-top': !_vm.list.length || _vm.isLoading
    }
  }, [_c('div', {
    staticClass: "app-channellist-content-container"
  }, [!_vm.isLoading ? _c('div', {
    staticClass: "app-channellist-nav"
  }, [_c('form', {
    staticClass: "u-form u-form--big app-channellist-search",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.search,
      expression: "search"
    }],
    staticClass: "u-input",
    attrs: {
      "placeholder": _vm.$t('do_search')
    },
    domProps: {
      "value": _vm.search
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.search = $event.target.value;
      }
    }
  }), _c('a', {
    staticClass: "u-button u-button-primary app-channellist-refresh",
    on: {
      "click": _vm.maybeUpdateList
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm.list.length ? _c('div', {
    staticClass: "app-channellist-pagination"
  }, [_c('a', {
    on: {
      "click": _vm.prevPage
    }
  }, [_c('i', {
    staticClass: "fa fa-step-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" " + _vm._s(_vm.page + 1) + " / " + _vm._s(_vm.maxPages + 1) + " "), _c('a', {
    on: {
      "click": _vm.nextPage
    }
  }, [_c('i', {
    staticClass: "fa fa-step-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()]) : _vm._e(), _vm.isLoading ? _c('div', {
    staticClass: "app-channellist-loading"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('p', [_vm._v("Chargement des salons en cours…")])]) : _vm.noResults ? _c('div', {
    staticClass: "app-channellist-info"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('channel_list_nonefound')))])]) : _c('div', {
    staticClass: "app-channellist-table"
  }, _vm._l(_vm.paginated, function (channel) {
    return _c('div', {
      key: channel.channel,
      staticClass: "app-channellist-grid"
    }, [_c('div', {
      staticClass: "app-channellist-users"
    }, [_vm._v(_vm._s(channel.num_users || 0))]), _c('div', {
      staticClass: "u-link app-channellist-name",
      on: {
        "click": function ($event) {
          return _vm.joinChannel(channel.channel);
        }
      }
    }, [_vm._v(_vm._s(channel.channel))]), _c('span', {
      staticClass: "app-channellist-topic",
      domProps: {
        "innerHTML": _vm._s(_vm.formatAndTrimTopic(channel.topic))
      }
    }), _c('div', {
      staticClass: "app-channellist-join"
    }, [_c('a', {
      staticClass: "u-button u-button-primary",
      on: {
        "click": function ($event) {
          return _vm.joinChannel(channel.channel);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('container_join')))])])]);
  }), 0), !_vm.isLoading && _vm.list.length ? _c('div', {
    staticClass: "app-channellist-nav"
  }, [_c('div', {
    staticClass: "app-channellist-pagination"
  }, [_c('a', {
    on: {
      "click": _vm.prevPage
    }
  }, [_c('i', {
    staticClass: "fa fa-step-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" " + _vm._s(_vm.page + 1) + " / " + _vm._s(_vm.maxPages + 1) + " "), _c('a', {
    on: {
      "click": _vm.nextPage
    }
  }, [_c('i', {
    staticClass: "fa fa-step-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e()])]);
};
var staticRenderFns = exports.staticRenderFns = [];